import { render, staticRenderFns } from "./SurveyGuru.vue?vue&type=template&id=00f859cc&scoped=true&"
import script from "./SurveyGuru.vue?vue&type=script&lang=js&"
export * from "./SurveyGuru.vue?vue&type=script&lang=js&"
import style0 from "./SurveyGuru.vue?vue&type=style&index=0&id=00f859cc&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "00f859cc",
  null
  
)

export default component.exports
import QDialog from 'quasar/src/components/dialog/QDialog.js';
import QCard from 'quasar/src/components/card/QCard.js';
import QCardSection from 'quasar/src/components/card/QCardSection.js';
import QBtn from 'quasar/src/components/btn/QBtn.js';
import QCheckbox from 'quasar/src/components/checkbox/QCheckbox.js';
import qInstall from "../../node_modules/vue-cli-plugin-quasar/lib/runtime.auto-import.js";
qInstall(component, 'components', {QDialog,QCard,QCardSection,QBtn,QCheckbox});
